import { roundToDecimalPlaces } from '@semios/app-platform-common'

export const formatDifference = (difference: number | null) => {
  if (difference === null) return '-'

  return `${roundToDecimalPlaces(difference, 0)}`
}
